import { Box, useBreakpointValue } from '@chakra-ui/react';
import DesktopSidebar from './DesktopSidebar';

interface DesktopLayoutProps {
  children: React.ReactNode;
}

export default function DesktopLayout({ children }: DesktopLayoutProps) {
  const isDesktop = useBreakpointValue({ base: false, lg: true });

  return (
    <Box display={{ base: 'block', lg: 'flex' }} minH="100vh">
      {isDesktop && <DesktopSidebar />}
      {/* overflowX: use `clip`, not `hidden`. `hidden` forces overflow-y to
          compute to `auto`, creating a scroll container that breaks
          `position: sticky` descendants (e.g. BrowseHeader's reveal-on-scroll).
          `clip` prevents horizontal overflow without creating that container. */}
      <Box flex={1} minW={0} overflowX="clip">
        {children}
      </Box>
    </Box>
  );
}
